/* @flow */
const width = '90vw'
const height = '90vh'
const CHECKOUT_OVERLAY_COLOR = {
    BLACK: 'black',
    WHITE: 'white'
}
export function getSandboxStyle({ ANIMATION, id }) {
    return `
        #${ id }.easyscale-checkout-sandbox {
            display: block;
            position: fixed;
            top: 0;
            left: 0;

            width: 100%;
            height: 100%;
            width: 100vw;
            height: 100vh;
            max-width: 100%;
            max-height: 100%;
            min-width: 100%;
            min-height: 100%;

            z-index: 2147483647;

            -webkit-animation-duration: 1s;
            animation-duration: 1s;

            animation-fill-mode:forwards;
            animation-iteration-count: 1;

            -webkit-animation-fill-mode:forwards;
            -webkit-animation-iteration-count: 1;
        }

        #${ id }.easyscale-checkout-sandbox .easyscale-checkout-sandbox-iframe {
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }

        @-webkit-keyframes ${ ANIMATION.SHOW_CONTAINER } {
            from {
                opacity: 0;
            }

            to {
                opacity: 1;
            }
        }

        @keyframes ${ ANIMATION.SHOW_CONTAINER } {
            from {
                opacity: 0;
            }

            to {
                opacity: 1;
            }
        }

        @-webkit-keyframes ${ ANIMATION.HIDE_CONTAINER } {
            from {
                opacity: 1;
            }

            50% {
                opacity: 1;
            }

            to {
                opacity: 0;
            }
        }

        @keyframes ${ ANIMATION.HIDE_CONTAINER } {
            from {
                opacity: 1;
            }

            50% {
                opacity: 1;
            }

            to {
                opacity: 0;
            }
        }
    `;
}

export function getContainerStyle({ id, tag, CONTEXT, CLASS, ANIMATION }){
    return `
       #${ id } {
            position: absolute;
            z-index: 2147483647;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;

            -webkit-transform: translate3d(0, 0, 0);
            -moz-transform: translate3d(0, 0, 0);
            -ms-transform: translate3d(0, 0, 0);
            -o-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }

        #${ id }.${ tag }-background-color-${ CHECKOUT_OVERLAY_COLOR.BLACK } {
            background-color: black;
            background-color: rgba(0, 0, 0, 0.8);

            background: -webkit-radial-gradient(50% 50%, ellipse closest-corner, rgba(0,0,0,0.6) 1%, rgba(0,0,0,0.8) 100%);
            background: -moz-radial-gradient(50% 50%, ellipse closest-corner, rgba(0,0,0,0.6) 1%, rgba(0,0,0,0.8) 100%);
            background: -ms-radial-gradient(50% 50%, ellipse closest-corner, rgba(0,0,0,0.6) 1%, rgba(0,0,0,0.8) 100%);
            background: radial-gradient(50% 50%, ellipse closest-corner, rgba(0,0,0,0.6) 1%, rgba(0,0,0,0.8) 100%);

            color: #fff;
        }

        #${ id }.${ tag }-background-color-${ CHECKOUT_OVERLAY_COLOR.WHITE } {
            background-color: white;
            background-color: rgba(255, 255, 255, 0.4);

            background: -webkit-radial-gradient(50% 50%, ellipse closest-corner, rgba(255, 255, 255,0.65) 1%, rgba(255, 255, 255,0.4) 100%);
            background: -moz-radial-gradient(50% 50%, ellipse closest-corner, rgba(255, 255, 255,0.65) 1%, rgba(255, 255, 255,0.4) 100%);
            background: -ms-radial-gradient(50% 50%, ellipse closest-corner, rgba(255, 255, 255,0.65) 1%, rgba(255, 255, 255,0.4) 100%);
            background: radial-gradient(50% 50%, ellipse closest-corner, rgba(255, 255, 255,0.65) 1%, rgba(255, 255, 255,0.4) 100%);

            color: #333;
        }

        #${ id }.${ tag }-background-color-${ CHECKOUT_OVERLAY_COLOR.BLACK } a {
            color: #fff;
        }

        #${ id }.${ tag }-background-color-${ CHECKOUT_OVERLAY_COLOR.WHITE } a {
            color: #333;
        }

        #${ id }.${ tag }-background-color-${ CHECKOUT_OVERLAY_COLOR.BLACK } .easyscale-checkout-close:before,
        #${ id }.${ tag }-background-color-${ CHECKOUT_OVERLAY_COLOR.BLACK } .easyscale-checkout-close:after {
            background-color: #fff;
        }

        #${ id }.${ tag }-background-color-${ CHECKOUT_OVERLAY_COLOR.WHITE } .easyscale-checkout-close:before,
        #${ id }.${ tag }-background-color-${ CHECKOUT_OVERLAY_COLOR.WHITE } .easyscale-checkout-close:after {
            background-color: #111;
        }

        #${ id }.${ tag }-context-${ CONTEXT.POPUP } {
            cursor: pointer;
        }

        #${ id }.${ tag }-context-${ CONTEXT.POPUP } {
            cursor: pointer;
        }

        #${ id } a {
            text-decoration: none;
        }

        #${ id } .easyscale-checkout-modal {
            font-family: "HelveticaNeue", "HelveticaNeue-Light", "Helvetica Neue Light", helvetica, arial, sans-serif;
            font-size: 14px;
            text-align: center;

            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            -ms-box-sizing: border-box;
            box-sizing: border-box;
            max-width: 350px;
            top: 50%;
            left: 50%;
            position: absolute;
            transform: translateX(-50%) translateY(-50%);
            -webkit-transform: translateX(-50%) translateY(-50%);
            -moz-transform: translateX(-50%) translateY(-50%);
            -o-transform: translateX(-50%) translateY(-50%);
            -ms-transform: translateX(-50%) translateY(-50%);
            cursor: pointer;
            text-align: center;
        }

        #${ id }.${ tag }-loading .easyscale-checkout-message, #${ id }.${ tag }-loading .easyscale-checkout-continue {
            display: none;
        }

        .easyscale-checkout-loader {
            display: none;
        }

        #${ id }.${ tag }-loading .easyscale-checkout-loader {
            display: block;
        }

        #${ id } .easyscale-checkout-modal .easyscale-checkout-logo {
            cursor: pointer;
            margin-bottom: 30px;
            display: inline-block;
        }

        #${ id } .easyscale-checkout-modal .easyscale-checkout-logo img {
            height: 36px;
        }

        #${ id } .easyscale-checkout-modal .easyscale-checkout-logo img.easyscale-checkout-logo-pp {
            margin-right: 10px;
        }

        #${ id } .easyscale-checkout-modal .easyscale-checkout-message {
            font-size: 15px;
            line-height: 1.5;
            padding: 10px 0;
        }

        #${ id }.${ tag }-context-${ CONTEXT.IFRAME } .easyscale-checkout-message, #${ id }.${ tag }-context-${ CONTEXT.IFRAME } .easyscale-checkout-continue {
            display: none;
        }

        #${ id } .easyscale-checkout-modal .easyscale-checkout-continue {
            font-size: 15px;
            line-height: 1.35;
            padding: 10px 0;
            font-weight: bold;
        }

        #${ id } .easyscale-checkout-modal .easyscale-checkout-continue a {
            border-bottom: 1px solid white;
        }

        #${ id } .easyscale-checkout-close {
            cursor: pointer;
            position: absolute;
            right: 16px;
            top: 16px;
            width: 16px;
            height: 16px;
            opacity: 0.6;
        }

        #${ id }.${ tag }-loading .easyscale-checkout-close {
            display: none;
        }

        #${ id } .easyscale-checkout-close:hover {
            opacity: 1;
        }

        #${ id } .easyscale-checkout-close:before, .easyscale-checkout-close:after {
            position: absolute;
            left: 8px;
            content: ' ';
            height: 16px;
            width: 2px;
        }

        #${ id } .easyscale-checkout-close:before {
            transform: rotate(45deg);
            -webkit-transform: rotate(45deg);
            -moz-transform: rotate(45deg);
            -o-transform: rotate(45deg);
            -ms-transform: rotate(45deg);
        }

        #${ id } .easyscale-checkout-close:after {
            transform: rotate(-45deg);
            -webkit-transform: rotate(-45deg);
            -moz-transform: rotate(-45deg);
            -o-transform: rotate(-45deg);
            -ms-transform: rotate(-45deg);
        }

        #${ id } .easyscale-checkout-iframe-container {
            display: none;
        }

        #${ id }.${ tag }-context-${ CONTEXT.IFRAME } .easyscale-checkout-iframe-container,
        #${ id }.${ tag }-context-${ CONTEXT.IFRAME } .easyscale-checkout-iframe-container > .${ CLASS.OUTLET },
        #${ id }.${ tag }-context-${ CONTEXT.IFRAME } .easyscale-checkout-iframe-container > .${ CLASS.OUTLET } > iframe {
            max-height: 95vh;
            max-width: 98vw;
        }

        #${ id }.${ tag }-context-${ CONTEXT.IFRAME } .easyscale-checkout-iframe-container {

            display: block;

            position: absolute;

            top: 50%;
            left: 50%;

            min-width: ${width};

            transform: translate(-50%, -50%);
            -webkit-transform: translate(-50%, -50%);
            -moz-transform: translate(-50%, -50%);
            -o-transform: translate(-50%, -50%);
            -ms-transform: translate(-50%, -50%);

            transform: translate3d(-50%, -50%, 0);
            -webkit-transform: translate3d(-50%, -50%, 0);
            -moz-transform: translate3d(-50%, -50%, 0);
            -o-transform: translate3d(-50%, -50%, 0);
            -ms-transform: translate3d(-50%, -50%, 0);

            border-radius: 10px;
            overflow: hidden;
        }

        #${ id }.${ tag }-context-${ CONTEXT.IFRAME } .${ CLASS.OUTLET } {

            position: relative;

            -webkit-transition: all 0.3s ease;
            -moz-transition: all 0.3s ease;
            -ms-transition: all 0.3s ease;
            -o-transition: all 0.3 ease;
            transition: all 0.3s ease;

            -webkit-animation-duration: 0.3s;
            animation-duration: 0.3s;
            -webkit-animation-fill-mode: both;
            animation-fill-mode: both;

            min-width: ${width};
            max-width: ${width};
            width: ${width};
            height: ${height};

            background-color: white;

            overflow: auto;
            -webkit-overflow-scrolling: touch;
        }

        #${ id }.${ tag }-context-${ CONTEXT.IFRAME } .${ CLASS.OUTLET } > iframe {
            position: absolute;
            top: 0;
            left: 0;
            transition: opacity .4s ease-in-out;
        }

        #${ id }.${ tag }-context-${ CONTEXT.IFRAME } .${ CLASS.OUTLET } > iframe.${ CLASS.COMPONENT_FRAME } {
            z-index: 100;
        }

        #${ id }.${ tag }-context-${ CONTEXT.IFRAME } .${ CLASS.OUTLET } > iframe.${ CLASS.PRERENDER_FRAME } {
            z-index: 200;
        }

        #${ id }.${ tag }-context-${ CONTEXT.IFRAME } .${ CLASS.OUTLET } > iframe.${ CLASS.VISIBLE } {
            opacity: 1;
            z-index: 200;
        }

        #${ id }.${ tag }-context-${ CONTEXT.IFRAME } .${ CLASS.OUTLET } > iframe.${ CLASS.INVISIBLE } {
            opacity: 0;
            z-index: 100;
        }

        #${ id }.${ tag }-context-${ CONTEXT.IFRAME } .${ CLASS.OUTLET } iframe {
            width: 1px;
            min-width: 100%;
            height: 100%;
        }

        @-webkit-keyframes ${ ANIMATION.SHOW_COMPONENT } {
            from {
                opacity: 0;
                transform: scale3d(.3, .3, .3);
                -webkit-transform: scale3d(.3, .3, .3);
            }

            to {
                opacity: 1;
                transform: scale3d(1, 1, 1);
                -webkit-transform: scale3d(1, 1, 1);
            }
        }

        @keyframes ${ ANIMATION.SHOW_COMPONENT } {
            from {
                opacity: 0;
                transform: scale3d(.3, .3, .3);
                -webkit-transform: scale3d(.3, .3, .3);
            }

            to {
                opacity: 1;
                transform: scale3d(1, 1, 1);
                -webkit-transform: scale3d(1, 1, 1);
            }
        }

        @-webkit-keyframes ${ ANIMATION.HIDE_COMPONENT } {
            from {
                transform: scale3d(1, 1, 1);
                -webkit-transform: scale3d(1, 1, 1);
            }

            to {
                opacity: 0;
                transform: scale3d(.3, .3, .3);
                -webkit-transform: scale3d(.3, .3, .3);
            }
        }

        @keyframes ${ ANIMATION.HIDE_COMPONENT } {
            from {
                transform: scale3d(1, 1, 1);
                -webkit-transform: scale3d(1, 1, 1);
            }

            to {
                opacity: 0;
                transform: scale3d(.3, .3, .3);
                -webkit-transform: scale3d(.3, .3, .3);
            }
        }

        .easyscale-spinner {
            height: 30px;
            width: 30px;
            display: inline-block;
            box-sizing: content-box;
            opacity: 1;
            filter: alpha(opacity=100);
            -webkit-animation: rotation .7s infinite linear;
            -moz-animation: rotation .7s infinite linear;
            -o-animation: rotation .7s infinite linear;
            animation: rotation .7s infinite linear;
            border-left: 8px solid rgba(0, 0, 0, .2);
            border-right: 8px solid rgba(0, 0, 0, .2);
            border-bottom: 8px solid rgba(0, 0, 0, .2);
            border-top: 8px solid #fff;
            border-radius: 100%
        }

        @-webkit-keyframes rotation {
            from {
                -webkit-transform: rotate(0deg)
            }
            to {
                -webkit-transform: rotate(359deg)
            }
        }
        @-moz-keyframes rotation {
            from {
                -moz-transform: rotate(0deg)
            }
            to {
                -moz-transform: rotate(359deg)
            }
        }
        @-o-keyframes rotation {
            from {
                -o-transform: rotate(0deg)
            }
            to {
                -o-transform: rotate(359deg)
            }
        }
        @keyframes rotation {
            from {
                transform: rotate(0deg)
            }
            to {
                transform: rotate(359deg)
            }
        }
    `;
}



// WEBPACK FOOTER //
// ./src/zoid/popup/containerStyle.js